import PlayIn from './playIn'
import { PlayInStatus } from './types'

export const PlayInType = {
  PlayInStatus
}
export default PlayIn
